/**
* @prop --uic-menu-bg-color-hover: background color when hovered
* @prop --uic-menu-text-color: default text and icon color
* @prop --uic-menu-text-color-active: text and icon color when the item is active
* @prop --uic-menu-text-color-focus: text and icon color when the item has focus
* @prop --uic-menu-text-color-selected: text and icon color when the item is selected
* @prop --uic-menu-text-color-disabled: text and icon color when the item is disabled
* @prop --uic-menu-border-color: outline color
* @prop --uic-menu-border-color-focus: outline color when the item has focus
* @prop --uic-menu-border-style: outline style
* @prop --uic-menu-border-width: outline thickness
*/
.uic-menu-item {
    flex: 0 0 auto;
    display: block;
    height: auto;
    min-height: var(--uic-menu-height);
    font-size: var(--uic-font-size-normal);
    line-height: var(--uic-line-height-normal);
    font-weight: var(--uic-font-weight-bold);
    color: var(--uic-menu-text-color);
    user-select: none;
    position: relative;

    .uic-menu.uic-menu--horizontal & {
        &[level="0"] > .uic-menu-item__dropdown {
            position: absolute;
            left: 0;
            top: var(--uic-menu-y-offset);
            min-width: 100%;
            width: max-content;
            overflow-y: auto;
            max-height: calc(100vh - var(--uic-menu-y-offset));
        }
    }

    /* stylelint-disable scss/selector-no-redundant-nesting-selector */
    .uic-menu-item__icon {
        flex: 0 0 auto;

        &.uic-menu-item__icon--expand,
        & + .uic-menu-item__label {
            margin-left: 8px;
        }
    }

    /* stylelint-enable scss/selector-no-redundant-nesting-selector */

    &:not([disabled]) {
        cursor: pointer;
    }

    &[disabled] {
        color: var(--uic-menu-text-color-disabled);
        pointer-events: none;
    }

    &:focus {
        outline: none;
    }

    &:focus > .uic-menu-item__item {
        color: var(--uic-menu-text-color-focus);
        outline: 2px solid var(--uic-menu-text-color-focus);
        outline-offset: -2px;
    }

    &[selected] > .uic-menu-item__item {
        color: var(--uic-menu-text-color-selected);

        &::after {
            display: block;
            content: "";
            left: 0;
            bottom: 0;
            width: 100%;
            height: 4px;
            background: var(--uic-menu-text-color-selected);
            position: absolute;
        }
    }

    .uic-menu-item__item {
        box-sizing: border-box;
        position: relative;
        padding: 0 15px;
        min-width: var(--uic-menu-height);
        height: auto;
        min-height: var(--uic-menu-height);
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        justify-content: space-between;
        color: inherit;
        text-decoration: none;
        background: var(--uic-menu-item-color-level-2);

        &:hover {
            background: var(--uic-menu-item-color-level-2-hover);
        }

        .uic-menu--vertical &,
        .uic-menu-item__submenu & {
            flex: 1 0 auto;
            justify-content: stretch;
        }

        .uic-menu-item__label {
            flex: 1 0 auto;
            white-space: nowrap;
            display: inline-block;
            position: relative;
        }

        .uic-menu-item__label.uic-menu-item__label--child-selected {
            font-weight: var(--uic-font-weight-normal);
            transform: translate(0, -10px);

            @media #{$breakpoint_tablet_small} {
                transform: translate(0, -8px);
            }
        }

        .uic-menu-item__label-selected-child {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: var(--uic-font-size-normal);
            line-height: var(--uic-line-height-normal);
            color: var(--uic-menu-text-color-hover);
            font-weight: var(--uic-font-weight-bold);
            display: block;
            position: absolute;
        }
    }

    &[level="0"] {
        > .uic-menu-item__item {
            background: var(--uic-menu-item-color-level-0);

            &:hover {
                background: var(--uic-menu-item-color-level-0-hover);
            }
        }
    }

    &[level="1"] {
        > .uic-menu-item__item {
            background: var(--uic-menu-item-color-level-1);

            &:hover {
                background: var(--uic-menu-item-color-level-1-hover);
            }
        }
    }

    &[level="3"] .uic-menu-item__label {
        padding-left: 15px;
    }

    .uic-menu-item__inner {
        display: flex;
        align-items: center;

        .uic-menu--vertical &,
        .uic-menu-item__submenu & {
            flex: 1 0 auto;
        }
    }

    .uic-menu-item__dropdown {
        display: none;
        position: relative;
    }

    &--expanded {
        > .uic-menu-item__item {
            .uic-menu-item__icon--expand {
                transform: rotate(180deg);
            }
        }

        > .uic-menu-item__dropdown {
            display: block;
        }
    }

    &--icon-only {
        > .uic-menu-item__item {
            justify-content: center;
        }
    }
}
